import { API_URL } from "../config/connect";

// Paid main-page banner slots (MainBannerSlot) moderation.
// Backend: app.api.promo_v2 admin_router → /api/v1/admin/banners/main/*
const authHeaders = (json = false) => {
  const token = localStorage.getItem("google_id_token");
  const h = { Authorization: `Bearer ${token}` };
  if (json) h["Content-Type"] = "application/json";
  return h;
};

const parseError = async (res, fallback) => {
  try {
    const d = await res.json();
    if (typeof d?.detail === "string") return d.detail;
    if (d?.detail?.message) return d.detail.message;
  } catch {}
  return fallback;
};

const request = async (url, options, fallback) => {
  const res = await fetch(url, options);
  if (!res.ok) {
    const msg = await parseError(res, fallback);
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return res.json();
};

const BASE = `${API_URL}/api/v1/admin/banners/main`;

const resolveItems = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

export const getPendingBanners = () =>
  request(
    `${BASE}/pending`,
    { method: "GET", headers: authHeaders() },
    "Не удалось получить список баннеров на модерации"
  ).then(resolveItems);

export const getActiveBanners = () =>
  request(
    `${BASE}/active`,
    { method: "GET", headers: authHeaders() },
    "Не удалось получить список активных баннеров"
  ).then(resolveItems);

export const approveBanner = (slotId) =>
  request(
    `${BASE}/${slotId}/approve`,
    { method: "POST", headers: authHeaders() },
    "Не удалось подтвердить баннер"
  );

export const rejectBanner = (slotId, reason) =>
  request(
    `${BASE}/${slotId}/reject`,
    {
      method: "POST",
      headers: authHeaders(true),
      body: JSON.stringify({ reason: reason || null }),
    },
    "Не удалось отклонить баннер"
  );

export const deactivateBanner = (slotId, { reason, refund } = {}) =>
  request(
    `${BASE}/${slotId}/deactivate`,
    {
      method: "POST",
      headers: authHeaders(true),
      body: JSON.stringify({ reason: reason || null, refund: Boolean(refund) }),
    },
    "Не удалось деактивировать баннер"
  );